import React from 'react';
import Modal from '../../components/Modal/Modal';
import { sugerirTroco } from '../../utils/trocoUtils';

const ModalTroco = ({ show, onClose, valorTotal, onSelecionarTroco }) => {
  const sugestoes = sugerirTroco(valorTotal);

  const estilosBotao = {
    padding: '10px 15px',
    borderRadius: '8px',
    backgroundColor: '#4caf50',
    color: 'white',
    fontSize: '16px',
    border: 'none',
    cursor: 'pointer',
    minWidth: '100px'
  };

  return (
    <Modal show={show} onClose={onClose} titulo='Troco'>
      <div style={{ padding: '10px', textAlign: 'center' }}>
        <p><strong>Valor total:</strong> R$ {valorTotal.toFixed(2).replace('.', ',')}</p>      
        <p>Deseja troco para qual valor?</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
          {sugestoes.map((valor, index) => (
            <button
              key={index}
              onClick={() => {
                onSelecionarTroco(valor);
                onClose();
              }}
              style={estilosBotao}
            >
              R$ {valor.toFixed(2).replace('.', ',')}
            </button>
          ))}

          {/* Opção de troco exato */}
          <button
            onClick={() => {
              onSelecionarTroco(null); // indica que não precisa de troco
              onClose();
            }}
            style={{
              ...estilosBotao,
              backgroundColor: '#757575'
            }}
          >
            ✅ Já tenho trocado
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTroco;